import React, { useState, useEffect } from "react";
import axios from "axios";
import LogoDark from "../../assets/LogoDark";
import { connect } from "react-redux";
import * as actions from "../../state/actions/onboarding";
import { Redirect } from "react-router-dom";

const md5 = require("md5");

const performPasswordConfirmation = (
  { email, code, newPassword1, newPassword2 },
  setLoading,
  setErrorMessage,
  setGoToLogin
) => {
  setLoading(true);
  setErrorMessage(null);
  if (newPassword1 !== newPassword2) {
    setErrorMessage("New Passwords do not match!");
    return;
  }
  axios
    .post(`${process.env.REACT_APP_BACKEND_URL}/confirmpassword`, {
      email,
      code,
      newPassword: md5(newPassword1)
    })
    .then(response => {
      console.log(response);
      setGoToLogin(true);
    })
    .catch(error => {
      setErrorMessage("Tomo, we have a problem!");
      console.log("Failed to Initiate PasswordRecovery: ", error);
    })
    .finally(() => {
      setLoading(false);
    });
};

function ConfirmPassword({ location }) {
  const [newPassword1, setNewPassword1] = useState(null);
  const [newPassword2, setNewPassword2] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [codeStatus, setCodeStatus] = useState(false);
  const [goToLogin, setGoToLogin] = useState(false);

  const { search } = location;
  console.log(search);
  const params = new URLSearchParams(search);
  const code = params.get("code");
  const email = params.get("email");

  useEffect(() => {
    // Update the document title using the browser API
    console.log("useEffect called");
    axios
      .post(`${process.env.REACT_APP_BACKEND_URL}/verifycode`, {
        email,
        code
      })
      .then(resp => {
        console.log("OKKKK", resp);
        setCodeStatus(resp.status === 200);
      })
      .catch(err => {
        console.log("NOT OKKKK");
        setCodeStatus(false);
      });
  }, []);

  const handleSubmit = () => {
    performPasswordConfirmation(
      {
        email,
        code,
        newPassword1,
        newPassword2
      },
      setLoading,
      setErrorMessage,
      setGoToLogin
    );
  };

  return goToLogin ? (
    <Redirect to="/login" />
  ) : !codeStatus ? (
    "Page Not Found"
  ) : (
    <div className="bg-gray-100 h-screen w-screen p-20 outerContainer">
      <div className="flex flex-col flex-shrink-0 p-6 max-w-sm my-20 mx-auto bg-white rounded border border-gray-300 innerContainer">
        <LogoDark
          className="text-4xl"
          black
          style={{ justifyContent: "center" }}
        />
        <input
          type="password"
          name="email"
          value={newPassword1}
          placeholder="Enter new password"
          className="w-full my-3 p-2 border border-gray-300 rounded-sm bg-white"
          onChange={e => {
            setNewPassword1(e.target.value);
          }}
        />
        <input
          type="password"
          name="email"
          value={newPassword2}
          placeholder="Re-Enter new password"
          className="w-full my-3 p-2 border border-gray-300 rounded-sm bg-white"
          onChange={e => {
            setNewPassword2(e.target.value);
          }}
        />
        <div className={errorMessage ? "text-red-600 p-2" : "hidden"}>
          {errorMessage}
        </div>
        <input
          type="button"
          name="button"
          onClick={() => handleSubmit()}
          value="Reset Password"
          className={`w-full p-4 bg-green-primary text-white rounded-sm loginButton ${
            loading ? "disabled opacity-50 cursor-not-allowed" : ""
          }`}
        />
      </div>
    </div>
  );
}

export default connect(
  state => ({}),
  actions
)(ConfirmPassword);
